import React from "react";
import Loader from "../../common/spinner";

function TransactLoading({ inTransition }) {
  if (!inTransition) return null;

  return (
    <div className="blurred-background uk-flex uk-flex-center uk-flex-middle uk-padding">
      <div className="bg-white shadow uk-padding rounded d-flex flex-column align-items-center">
        <Loader multiplier={2} />
        <p className="para-one uk-padding-small text-left">
          Please wait as we are processing your order, this will only take a
          while.
        </p>
      </div>
    </div>
  );
}

export default TransactLoading;
